:host {
  --disabled-text-color: var(--grey-layout-200-disabled);
  display: inline-block;
  position: relative;
  width: auto;
  height: auto;
}

.menu-action-icon {
  font-size: 32px;
  width: 19px;
  height: 31px;
}

:host([disabled]) {
  pointer-events: none;
  transition: none;

  .menu-button::part(button) {
    color: var(--disabled-text-color);
  }
}

gz-single-select-list {
  --display-search-on-loading: block !important;
  --spinner-margin: auto;
  --spinner-size-transform: scale(2);
  --search-width: 99%;
  --search-top: 3px;
}

:host([isloading]) {
  #list-wrapper {
    height: 346px;
  }
}
